//  For each product on the page
document.querySelectorAll('.giftProduct').forEach(section => {
    const product = JSON.parse(section.querySelector(".giftProductJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;

    /************
     Product Swiper
     ************/

    const productSwiper = new Swiper(section.querySelector(".giftProductVisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoHeight: true,
        pagination: {
            el: '.giftProductVisualSwiper .swiper-pagination',
            clickable: true
        }
    });

    // play video on slide play click
    section.querySelectorAll(".giftProductVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".giftProductVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".giftProductVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });


    /**************
     Allergy Warning
     ***************/

    section.querySelector('.giftProductAllergyButton').addEventListener('click', function () {
        this.classList.toggle('active');
    })

    section.querySelector('.giftProductAllergyPopupExit').addEventListener('click', function () {
        this.closest('.giftProductAllergy').querySelector('.giftProductAllergyButton').classList.remove('active');
    })

    /**************
     Update Product
     ***************/

    // update active variant on input changes
    section.querySelectorAll(".giftProduct input").forEach(function (element) {
        element.addEventListener("change", function () {
            // open the recipient form
            if (this.classList.contains('productGiftRecipientCheckInput')) {
                section.querySelector('.productGiftRecipientFormWrap')?.classList.toggle('active');
            }
            updateProduct().catch((e) => console.error(e));
        });
    })

    async function updateProduct() {

        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.giftProductOptionItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".giftProductATC").disabled = true;
            section.querySelector(".giftProductATC").textContent = "Not Available";
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         Price
         ***************/

        section.querySelector(".giftProductPriceReal").textContent = price(activeVariant.price * quantity);
        if (activeVariant.compare_at_price > activeVariant.price) {
            section.querySelector(".giftProductPriceReal").classList.add("sale");
            section.querySelector(".giftProductPriceCompare").textContent = price(activeVariant.compare_at_price * quantity);
        } else {
            section.querySelector(".giftProductPriceReal").classList.remove("sale");
            section.querySelector(".giftProductPriceCompare").textContent = "";
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".giftProductATC").disabled = false;
            section.querySelector(".giftProductATC").textContent = "Add To Cart";
        } else {
            section.querySelector(".giftProductATC").disabled = true;
            section.querySelector(".giftProductATC").textContent = "Sold Out";
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch((e) => console.error(e));

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".giftProductQuantityBtn.minus")?.addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".giftProductQuantityValue").textContent = quantity.toString();
        updateProduct().catch((e) => console.error(e));
    });

    // plus
    section.querySelector(".giftProductQuantityBtn.plus")?.addEventListener("click", function () {
        quantity++;
        section.querySelector(".giftProductQuantityValue").textContent = quantity.toString();
        updateProduct().catch((e) => console.error(e));
    });


    /**************
     Product ATC
     ***************/

    section.querySelector('.giftProductATC').addEventListener("click", async function () {

        // add loading animation
        this.classList.add("loading");

        // check for additional options
        let properties = {};

        // if form is checked, add information to properties
        if (section.querySelector('.productGiftRecipientCheckInput').checked) {
            const inputs = section.querySelectorAll('.productGiftRecipientFormInput');
            for (let i = 0; i < inputs.length; i++) {
                const input = inputs[i];
                // if email is empty, return and notify
                if (input.name === 'Recipient email' && input.value === '') {
                    section.querySelector('.productGiftRecipientFormError').classList.add('active');
                    // remove animation
                    this.classList.remove("loading");
                    return;
                }
                if (input.value !== '') {
                    properties[input.name] = input.value;
                }
            }
            // add special property
            if (Object.keys(properties).length !== 0) {
                properties["__shopify_send_gift_card_to_recipient"] = true;
            }
        }

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
                properties: properties
            }]
        };

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        window.location.href = '/cart'
    });
});